import { FastField, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../redux/slices/CommonSlice";
import { useTranslation } from "react-i18next";
import { NumberInputKeyDown } from "../../helpers/numberInput";
import { Button } from "react-bootstrap";
import Select from "react-select";

const Step1 = () => {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { handleChange, handleBlur, values, touched, errors, setFieldValue } =
    useFormikContext();

  const { categories } = useSelector((state) => state.commonStore);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const categoryOptions = categories?.map((category) => ({
    value: category.id,
    label: category.name,
  }));

  const categorySelectStyles = {
    control: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    valueContainer: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    input: (base) => ({
      ...base,
      fontSize: "13px",
    }),
    option: (base) => ({
      ...base,
      fontSize: "12px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontSize: "13px",
    }),
  };

  const selectedCategoryOptions = Array.isArray(values.category)
    ? categoryOptions?.filter((opt) => values.category.includes(opt.value))
    : [];

  return (
    <>
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          name="fullName"
          placeholder={`${t("Enter Full Name")} *`}
          onChange={handleChange}
          value={values.fullName}
          onBlur={handleBlur}
        />
        {touched.fullName && errors.fullName && (
          <div className="text-danger">{errors.fullName}</div>
        )}
      </div>
      <div className="mb-3">
        {/* <label for="companyName" className="form-label visually-hidden">
          Company Name
        </label> */}
        <input
          type="text"
          className="form-control"
          id="companyName"
          name="companyName"
          placeholder={`${t("Company Name")} *`}
          onChange={handleChange}
          value={values.companyName}
          onBlur={handleBlur}
        />
        {touched.companyName && errors.companyName && (
          <div className="text-danger">{errors.companyName}</div>
        )}
      </div>
      <div className="mb-3">
        <input
          type="email"
          className="form-control"
          name="email"
          placeholder={`${t("Enter your email")} *`}
          onChange={handleChange}
          value={values.email}
          onBlur={handleBlur}
        />
        {touched.email && errors.email && (
          <div className="text-danger">{errors.email}</div>
        )}
      </div>
      <div className="mb-3">
        <input
          type="tel"
          className="form-control"
          name="mobileNumber"
          placeholder={`${t("Enter Whatsapp Number")} *`}
          onChange={handleChange}
          value={values.mobileNumber}
          onBlur={handleBlur}
          onKeyDown={(e) => NumberInputKeyDown(e)}
        />
        {touched.mobileNumber && errors.mobileNumber && (
          <div className="text-danger">{errors.mobileNumber}</div>
        )}
      </div>
      <div className="mb-3">
        <Select
          inputId="category"
          isMulti
          name="category"
          options={categoryOptions}
          value={selectedCategoryOptions}
          styles={categorySelectStyles}
          closeMenuOnSelect={false}
          onChange={(selected) => {
            const ids = Array.isArray(selected)
              ? selected.map((o) => o.value)
              : [];
            setFieldValue("category", ids);
          }}
          onBlur={handleBlur}
          placeholder={`${t("Business category")}`}
          isClearable
          classNamePrefix="select"
        />
        {/* {Array.isArray(selectedCategoryOptions) &&
          selectedCategoryOptions.length > 0 && (
            <div className="mt-2 d-flex flex-wrap gap-2">
              {selectedCategoryOptions.map((opt) => {
                return (
                  <span key={opt.value} className="badge bg-secondary">
                    {opt.label}
                  </span>
                );
              })}
            </div>
          )} */}
        {touched.category && errors.category && (
          <div className="text-danger">{errors.category}</div>
        )}
      </div>

      <div className="mb-3" style={{ position: "relative" }}>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          name="password"
          placeholder={`${t("Enter your password")} *`}
          onChange={handleChange}
          value={values.password}
          onBlur={handleBlur}
        />
        <Button
          variant="link"
          className="show-hide-btn"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <i className="fa fa-eye"></i>
          ) : (
            <i className="fa fa-eye-slash"></i>
          )}
        </Button>
        {touched.password && errors.password && (
          <div className="text-danger">{errors.password}</div>
        )}
      </div>
      <div className="mb-4" style={{ position: "relative" }}>
        <input
          type={showConfirmPassword ? "text" : "password"}
          className="form-control"
          name="confirmPassword"
          placeholder={`${t("Confirm your password")} *`}
          onChange={handleChange}
          value={values.confirmPassword}
          onBlur={handleBlur}
        />
        <Button
          variant="link"
          className="show-hide-btn"
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        >
          {showConfirmPassword ? (
            <i className="fa fa-eye"></i>
          ) : (
            <i className="fa fa-eye-slash"></i>
          )}
        </Button>
        {touched.confirmPassword && errors.confirmPassword && (
          <div className="text-danger">{errors.confirmPassword}</div>
        )}
      </div>
    </>
  );
};

export default Step1;
